'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.format = exports.parse = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _filter = require('lodash/filter');

var _filter2 = _interopRequireDefault(_filter);

var _map = require('lodash/map');

var _map2 = _interopRequireDefault(_map);

var _trim = require('lodash/trim');

var _trim2 = _interopRequireDefault(_trim);

var _trimStart = require('lodash/trimStart');

var _trimStart2 = _interopRequireDefault(_trimStart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sanitizePath = function sanitizePath() {
  for (var _len = arguments.length, paths = Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return (0, _filter2.default)((0, _map2.default)(paths, function (s) {
    return s && (0, _filter2.default)((0, _map2.default)(s.split('/'), _trim2.default)).join('/');
  })).join('/');
};

var parse = exports.parse = function parse(string) {
  var object = {};

  var _string$split = string.split('://');

  var _string$split2 = _slicedToArray(_string$split, 2);

  var type = _string$split2[0];
  var rest = _string$split2[1];

  if (type === 'file') {
    object.type = 'file';
    object.path = '/' + (0, _trimStart2.default)(rest, '/'); // the leading slash has been forgotten on client side first implementation
  } else if (type === 'nfs') {
      object.type = 'nfs';

      var _rest$split = rest.split(':');

      var _rest$split2 = _slicedToArray(_rest$split, 2);

      var host = _rest$split2[0];
      var path = _rest$split2[1];

      object.host = host;
      object.path = '/' + (0, _trimStart2.default)(path, '/'); // takes care of a missing leading slash coming from previous version format
    } else if (type === 'smb') {
        object.type = 'smb';
        var lastAtSign = rest.lastIndexOf('@');
        var smb = rest.slice(lastAtSign + 1);
        var auth = rest.slice(0, lastAtSign);
        var firstColon = auth.indexOf(':');
        var username = auth.slice(0, firstColon);
        var password = auth.slice(firstColon + 1);

        var _smb$split = smb.split('\\\\');

        var _smb$split2 = _slicedToArray(_smb$split, 2);

        var domain = _smb$split2[0];
        var sh = _smb$split2[1];

        var _sh$split = sh.split('\0');

        var _sh$split2 = _slicedToArray(_sh$split, 2);

        var _host = _sh$split2[0];
        var _path = _sh$split2[1];

        object.host = _host;
        object.path = _path;
        object.domain = domain;
        object.username = username;
        object.password = password;
      }
  return object;
};

var format = exports.format = function format(_ref) {
  var type = _ref.type;
  var host = _ref.host;
  var path = _ref.path;
  var username = _ref.username;
  var password = _ref.password;
  var domain = _ref.domain;

  type === 'local' && (type = 'file');
  var string = type + '://';
  if (type === 'nfs') {
    string += host + ':';
  }
  if (type === 'smb') {
    string += username + ':' + password + '@' + domain + '\\\\' + host;
  }
  path = sanitizePath(path);
  if (type === 'smb') {
    path = path.split('/');
    path = '\0' + path.join('\\'); // FIXME saving with the windows fashion \ was a bad idea :,(
  } else {
      path = '/' + path;
    }
  string += path;
  return string;
};
//# sourceMappingURL=index.js.map